import { createContext, useContext, useState, useCallback } from 'react';
import SendMessageDialog from '../components/SendMessageDialog';

const MessageContext = createContext(null);

/**
 * Mounted once at the top of the admin tree. Any descendant can call
 * `useMessagePlayer().open(user)` to pop the message dialog — no prop
 * drilling, no duplicate dialogs.
 */
export const MessagePlayerProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const open = useCallback((u) => setUser(u || null), []);
    const close = useCallback(() => setUser(null), []);

    return (
        <MessageContext.Provider value={{ open, close }}>
            {children}
            <SendMessageDialog open={!!user} user={user} onClose={close} />
        </MessageContext.Provider>
    );
};

export const useMessagePlayer = () => {
    const ctx = useContext(MessageContext);
    // Safe fallback when used outside the provider — log + no-op so nothing crashes
    if (!ctx) return { open: () => console.warn('useMessagePlayer outside provider'), close: () => {} };
    return ctx;
};
